var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.value !== 'fa-times')?_c('span',{staticClass:"text-h5 bold",style:({'color': _vm.value === 'Н/А' || _vm.value === '2' || _vm.value === '1' ? 'red' : ''})},[_vm._v("\n    "+_vm._s(_vm.value)+"\n  ")]):_c('v-icon',{attrs:{"small":""}},[_vm._v("\n    "+_vm._s(_vm.value)+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }